import Navbar from "@/components/navbar/Navbar.vue";
import i18n from "@/i18n";
import Card from "@/components/card/Card.vue";
import SectionDetailHero from "@/components/sectionDetailHero/SectionDetailHero.vue";
import LocalizedLink from "@/components/LocalizedLink.vue";

export default {
    name: "SectionDetail",
    props: {},
    components: {
        Navbar,
        Card,
        SectionDetailHero,
        LocalizedLink
    },
    data() {

        let filters = i18n.t("filters")

        return {
            sorts: filters.sorting,
            sortSelected: [],
            solutions: [],
            geos: [],

            urbanSectors: this.$store.getters.getUrbanSectors,
            urbanEnvironments: this.$store.getters.getUrbanEnvironments,
            geography: this.$store.getters.getGeography,
            typeOfSolutions: this.$store.getters.getTypeOfSolutions,

            activeUrbanSectors: this.$store.getters.getActiveUrbanSectors,

            activeUrbanEnvironmentOrGeography: '',

            projectOfSection: [],
            projectOfSectionInit: [],
            checkedTypeOfSolutions: [],
            checkedGeography: [],
            content: {},
            keySection: "",
            previousAndNextObj: {prevKey: '', nextKey: '', prevTitle: '', nextTitle: '',},

            selectedSort: null,
            numberViewProject: 6,
            maxProjectLoaded: false,
            sectionIsFiltered: false,
            checkedFilter: false,
            counterInView: 0
        }
    },

    mounted() {
        this.sectionInit();
        // $( "input" ).on( "click", function() {
        //     console.log($( "input:checked:after" ).val() + " is checked!");
        //   });
    },
    computed: {},
    methods: {
        sectionInit() {
            this.getDataFromParams();
            this.resetFilterTypeOfSolution();
            this.resetFilterGeography();
            this.getPreviusAndNextKey();
            this.populateFilterSelect();
        },
        getDataFromParams() {
            this.section = this.$route.params.section;
            // console.log('this.section', this.section)

            if (this.$route.params.urbanEnvironmentOrGeography === 'urbanenvironments') {
                this.$store.commit('setActiveUrbanEnvironmentOrGeography', 'urbanEnvironments');
                this.activeUrbanEnvironmentOrGeography  = 'urbanEnvironments';
                this.keySection = this.$store.getters.getUrbanEnvironmentKeyFromUrlParams(this.section);
                this.content = i18n.t("urbanEnvironments." + this.keySection);
                this.projectOfSectionInit = this.$store.getters.getProjectsOfUrbanEnvironment(this.section)
            } else if (this.$route.params.urbanEnvironmentOrGeography === 'geography') {
                this.$store.commit('setActiveUrbanEnvironmentOrGeography', 'geography');
                this.activeUrbanEnvironmentOrGeography  = 'geography';
                this.projectOfSectionInit = this.$store.getters.getProjectsOfGeography(this.section)
                this.keySection = this.$store.getters.getGeographyKeyFromUrlParams(this.section);
                this.content = i18n.t("geography." + this.keySection);
            }
            this.projectOfSectionInit = this.filterFromUrbanSector(this.projectOfSectionInit, this.activeUrbanEnvironmentOrGeography, this.activeUrbanSectors)
        },

        filterFromUrbanSector(projects, activeUrbanEnvironmentOrGeography, activeUrbanSectors) {
            if (activeUrbanSectors && activeUrbanSectors.id) {
                projects = projects.filter(project => {
                    return project.urbanSectors.includes(activeUrbanSectors.id)
                })
            }
            return projects;
        },

        resetFilterTypeOfSolution() {
            this.checkedTypeOfSolutions = [];
            this.projectOfSection = Object.assign({}, this.projectOfSectionInit);
            this.applyFilter();
        },
        resetFilterGeography() {
            this.checkedGeography = [];
            this.projectOfSection = Object.assign({}, this.projectOfSectionInit);
            this.applyFilter();
        },
        applyFilter() {
            this.projectOfSection = this.projectOfSectionInit
                .filter(proj => {
                    if (this.checkedTypeOfSolutions.length > 0) {
                        return proj.typeOfSolution.some(r => this.checkedTypeOfSolutions.includes(r))
                    } else {
                        return proj
                    }
                })


            this.projectOfSection = this.projectOfSection
                .filter(proj => {
                    if (this.checkedGeography.length > 0) {
                        console.log('proj', proj)
                        return proj.geography.some(r => this.checkedGeography.includes(r))
                    } else {
                        return proj
                    }
                })

            // console.log(' this.projectOfSection',  this.projectOfSection)

            this.counterInView = this.projectOfSection.length;
            this.projectOfSection = this.projectOfSection.slice(0, this.numberViewProject);

            if (this.checkedTypeOfSolutions.length > 0 || this.checkedGeography.length > 0) {
                this.checkedFilter = true;
            } else {
                this.checkedFilter = false;
            }
        },

        getPreviusAndNextKey() {
            let activeListEnvironment = [];

            activeListEnvironment = this.activeUrbanSectors[this.activeUrbanEnvironmentOrGeography];
            if (!activeListEnvironment) {
                if(this.activeUrbanEnvironmentOrGeography === 'geography'){
                    activeListEnvironment = this.geography.map(geography => geography.key);
                }else{
                    activeListEnvironment = this.urbanEnvironments.map(urbanEnvironment => urbanEnvironment.key);
                }
            }
            // console.log('activeListEnvironment', activeListEnvironment)
            if(activeListEnvironment.length > 3){
                this.previousAndNextObj = {prevKey: "", nextKey: "", prevTitle: "", nextTitle: ""};

                let keySectionIndex = activeListEnvironment.indexOf(this.keySection);
                // console.log('keySectionIndex', keySectionIndex)

                if (keySectionIndex === activeListEnvironment.length - 1) {
                    this.previousAndNextObj = {
                        prevKey: activeListEnvironment[keySectionIndex - 1],
                        nextKey: activeListEnvironment[0],
                        prevTitle: i18n.t(`${this.activeUrbanEnvironmentOrGeography}.${activeListEnvironment[keySectionIndex - 1]}.SectionDetailHero.title`),
                        nextTitle: i18n.t(`${this.activeUrbanEnvironmentOrGeography}.${activeListEnvironment[0]}.SectionDetailHero.title`)
                    }
                } else if (keySectionIndex === 0) {
                    this.previousAndNextObj = {
                        prevKey: activeListEnvironment[activeListEnvironment.length - 1],
                        nextKey: activeListEnvironment[1],
                        prevTitle: i18n.t(`${this.activeUrbanEnvironmentOrGeography}.${activeListEnvironment[activeListEnvironment.length - 1]}.SectionDetailHero.title`),
                        nextTitle: i18n.t(`${this.activeUrbanEnvironmentOrGeography}.${activeListEnvironment[1]}.SectionDetailHero.title`)
                    }
                } else {
                    this.previousAndNextObj = {
                        prevKey: activeListEnvironment[keySectionIndex - 1],
                        nextKey: activeListEnvironment[keySectionIndex + 1],
                        prevTitle: i18n.t(`${this.activeUrbanEnvironmentOrGeography}.${activeListEnvironment[keySectionIndex - 1]}.SectionDetailHero.title`),
                        nextTitle: i18n.t(`${this.activeUrbanEnvironmentOrGeography}.${activeListEnvironment[keySectionIndex + 1]}.SectionDetailHero.title`)
                    }
                }
            }
            else if(activeListEnvironment.length === 2){
                activeListEnvironment = activeListEnvironment.filter(item => item != this.keySection)
                this.previousAndNextObj = {
                    prevKey: activeListEnvironment,
                    prevTitle: i18n.t(`${this.activeUrbanEnvironmentOrGeography}.${activeListEnvironment}.SectionDetailHero.title`),
                }
            }
            // console.log('this.previousAndNextObj', this.previousAndNextObj)
        },

        goToRoute(keySection) {
            // console.log('gotToRoute(sectionKey)', keySection);
            this.$router.push({
                name: 'sectionDetail',
                params: {
                    urbanEnvironmentOrGeography: this.$route.params.urbanEnvironmentOrGeography.toLowerCase(),
                    section: String(keySection).toLowerCase(),

                }
            })
                .catch(() => {
                });

        },

        loadMore(number) {
            this.numberViewProject = this.numberViewProject + number;
            this.applyFilter();
        },

        populateFilterSelect() {
            let geographyTemp = [];
            let typeOfSolutionTemp = [];

            this.projectOfSectionInit.forEach(project => {
                geographyTemp.push(...project.geography);
                typeOfSolutionTemp.push(...project.typeOfSolution);
            })
            this.geos = this.geography.filter( geography => geographyTemp.includes(geography.key))
            this.solutions = this.typeOfSolutions.filter( typeOfSolutions => typeOfSolutionTemp.includes(typeOfSolutions.id))
        }
    },
    watch: {
        $route(to, from) {
            this.sectionInit()
        }
    }
};
